import { defineMessages } from 'react-intl';

export default defineMessages({
  imageTooLarge: {
    id: 'imageTooLarge',
    defaultMessage: 'This website does not accept images larger than {limit}MB',
  },
  invalidFileExtension: {
    id: 'invalidFileExtension',
    defaultMessage:
      'Only the following extensions are allowed: gif, jpeg, jpg, png, webp, doc, xls, csv, ppt, docx, xlsx, pptx, odt, ods, odp, otp, pdf, txt, zip.',
  },
  filesTooLarge: {
    id: 'filesTooLarge',
    defaultMessage: 'The file is too large. Maximum allowed size: {limit}MB',
  },
});
